import { DomainError } from '@dma/shared';

export class InvalidImageFileError extends DomainError {
  constructor(reason: string) {
    super('INVALID_IMAGE_FILE', `Image file is invalid: ${reason}`);
    this.name = 'InvalidImageFileError';
    Object.setPrototypeOf(this, InvalidImageFileError.prototype);
  }
}
